import { from, HttpLink } from '@apollo/client';
import config from 'config';
import activityMiddleware from './activity';
import analyticsMiddleware from './analytics';
import authMiddleware from './auth';
import errorMiddleware from './error';
// import persistedQueriesMiddleware from "./pq";
import retryMiddleware from './retry';

const getGraphQLUri = () => {
  // Use same-origin to ensure cookies are sent automatically
  // The /graph endpoint is proxied via Cloudflare Pages Functions
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/graph`;
  }
  // Fallback for SSR/build time
  return config.apollo.uri;
};

const httpLink = new HttpLink({
  uri: getGraphQLUri(),
  credentials: 'include',
});

const link = from([
  authMiddleware,
  activityMiddleware,
  analyticsMiddleware,
  errorMiddleware,
  retryMiddleware,
  // persistedQueriesMiddleware,
  httpLink,
]);

export default link;
